import baseApi from "../../../Lib/api/baseApi";
import endpoints from "../../../Lib/api/endpoints";

const getEntityId = (entity, fallback) =>
  entity?.id || entity?._id || entity?.feeId || fallback;

const normalizeFee = (fee, index = 0) => ({
  ...fee,
  id: getEntityId(fee, `fee_${index}`),
});

export const AccountApi = baseApi.injectEndpoints({
  tagTypes: ["Account", "Fee"],
  endpoints: (builder) => ({
    getAccountMetrics: builder.query({
      query: (data) => ({
        ...endpoints.getAccountMetrics(data),
      }),
      transformResponse: (response) => {
        return response;
      },
    }),
    getWallet: builder.query({
      query: () => ({
        ...endpoints.getWallet,
      }),
      transformResponse: (response) => {
        return response;
      },
    }),
    getPeriodicEarnings: builder.query({
      query: (data) => ({
        ...endpoints.getPeriodicTotalEarnings(data),
      }),
      transformResponse: (response) => {
        return response;
      },
      providesTags: (result) =>
        result
          ? [{ type: "Accounts", id: "LIST" }]
          : [{ type: "Accounts", id: "LIST" }],
    }),
    postInitiatePayout: builder.mutation({
      query: (data) => ({
        ...endpoints.completePayment,
        data,
      }),
      invalidatesTags: [{ type: "Accounts", id: "LIST" }],
    }),
    getAllFees: builder.query({
      query: (data) => ({
        ...endpoints.getAllFees(data),
      }),
      transformResponse: (response) => ({
        data: (response?.data?.data || []).map(normalizeFee),
        page: response?.data?.page || 0,
        total: response?.data?.total || 0,
        limit: response?.data?.limit || 0,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map((fee) => ({ type: "Fee", id: fee.id })),
              { type: "Fee", id: "All" },
            ]
          : [{ type: "Fee", id: "All" }],
    }),
    createFee: builder.mutation({
      query: (body) => ({
        ...endpoints.createFee,
        data: body,
      }),
      invalidatesTags: [{ type: "Fee", id: "All" }],
    }),
    updateFee: builder.mutation({
      query: ({ id, body }) => ({
        ...endpoints.updateFee(id),
        data: body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Fee", id: "All" },
        { type: "Fee", id },
      ],
    }),
    deleteFee: builder.mutation({
      query: (id) => ({
        ...endpoints.deleteFee(id),
      }),
      invalidatesTags: [{ type: "Fee", id: "All" }],
    }),
  }),
});

export const {
  useGetAccountMetricsQuery,
  useGetPeriodicEarningsQuery,
  usePostInitiatePayoutMutation,
  useGetWalletQuery,
  useGetAllFeesQuery,
  useCreateFeeMutation,
  useUpdateFeeMutation,
  useDeleteFeeMutation,
} = AccountApi;
